module.exports = "/_next/static/images/457bfe163072c72a1ce87585778a3541-nubanker-xpeer@0.75x.jpg.webp";